export default "__VITE_ASSET__Ch5r_E58__"